<div class="alert alert-success" *ngIf="alertSuccess">
  Announcement saved successfully!
</div>
<div class="alert alert-success" *ngIf="alertUpdateSuccess">
  Announcement updated successfully!
</div>
<div class="alert alert-danger" *ngIf="alertFailure">
  {{errorMsg}} !
</div>
<div class="alert alert-success" *ngIf="deleteSuccess">
  Announcement deleted successfully!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<div class="alert alert-danger" *ngIf="errorMsgUploadSave">
  Uploading failed and data will not be saved!
</div>

<div class="common-padding">
  <div class="col-md-12 col-xs-12 col-sm-12 heading mt-3 p-0 mb-4">
    <span class="span-create-edit-hoshin color">CHAPTER ANNOUNCEMENT</span>
    <span class="pt-1" style="font-size: 13px;"><a href="assets/userguides/ChapterAnnouncementUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
  </div>
  <form class="admin-font-style" (ngSubmit)="onChapterAnnouncementSubmit()" action="" name="chapterAnnouncementForm"
    #chapterAnnouncementForm="ngForm" enctype="multipart/form-data">
    <div>
      <div class="col-md-6 inlineFlex leftFloat zeroLeftPad" [ngClass]="{'pointerDisable': editandSavebtn ==true && savebtn == false}">
        <label for="selectSite" class="col-md-3 zeroLeftPad">Select Site<span class="star"> *</span></label>
        <ng-select id="selectSite" [ngClass]="{'disableSection': editandSavebtn ==true && savebtn == false}" placeholder="--Select Site--" class="col-md-8" [items]="siteList" name="siteName"
          bindLabel="siteName" [(ngModel)]="selectedSite" (change)="siteChange($event)" required></ng-select>
      </div>
      <div class="col-md-6 inlineFlex zeroRightPad" [ngClass]="{'pointerDisable': editandSavebtn ==true && savebtn == false}">
        <span class="divide-width"></span>
        <label for="selectBpg" class="col-md-3">Select ERG <span class="star"> *</span></label>
        <ng-select id="selectBpg" [ngClass]="{'disableSection': editandSavebtn ==true && savebtn == false}" placeholder="--Select ERG--" class="col-md-8 zeroRightPad" [items]="bpgList" name="bpgName"
          bindLabel="bpgName" [(ngModel)]="selectedBpg" (change)="bpgChange($event)" required></ng-select>
      </div>

         
      <div class="col-md-6 inlineFlex leftFloat zeroLeftPad">
        <label class="col-md-3 zeroLeftPad" [ngClass]="{'addMargin': eventPicture == false}" for="docName">Title<span
            class="star">*</span>
            <div class="errorMessage" style="font-size: 12px">(Max. 100 characters allowed)</div></label>

        <input type="text" [maxlength]="100" class="form-control col-md-8 zeroRightPad placeholder" name="announcementTitle"
          id="announcementTitle" placeholder="Enter Title" [(ngModel)]="announcementTitle" required>
      </div>
      <div class="col-md-6 inlineFlex zeroRightPad">
        <span class="divide-width"></span>
        <label class="col-md-3" [ngClass]="{'addMargin': eventPicture == false}" for="docName">Link
        <div class="errorMessage" style="font-size: 12px">(Max. 200 characters allowed)</div></label>

        <input type="text" [maxlength]="200" class="form-control col-md-8 zeroRightPad placeholder" name="externalLinks"
          id="externalLinks" placeholder="Enter Link" [(ngModel)]="externalLinks" (keyup)="onLinkType($event,'news')" >
      </div>
      <div class="col-md-6 inlineFlex leftFloat zeroLeftPad">
        <label class="col-md-3 zeroLeftPad upload-label-padding" for="UploadDocument">Upload</label>

        <input  #myInput type="file" id="UploadDocument" (change)="onFileSelected($event)" name="UploadDocument"
          placeholder="Upload" class="form-control input-lg upload-icon hideInput">
        <label  class="form-control input-lg upload-icon col-md-8 width-label" for="UploadDocument"><label
            class="docNameEllipsis resource-ellipsis col-md-8 upload-file-name-class ">{{selectedFileName}}</label>
          <p class="formats-font">(jpg, jpeg, png, pdf, ppt, pptx, txt, doc, docx, xlsx, csv)</p>
          <p class="errorMessage" *ngIf="fileSizeExtensionError" style="align-items: center">You can only upload the
            file of size less than 500 MB </p>
          <p class="errorMessage" *ngIf="fileExtensionError" style="align-items: center">Invalid format</p>
        
            <p class="errorMessage" *ngIf="announceLinkValid" style="align-items: center"> Enter valid link</p>
         
        </label>

      </div>

     

      <div class="col-md-6 inlineFlex zeroRightPad">
        <span class="divide-width"></span>
        <label class="col-md-3" [ngClass]="{'addMargin': eventPicture == false}" for="docName">Description<span
            class="star">*</span>        <div class="errorMessage" style="font-size: 12px">(Max. 500 characters allowed)</div></label>  

            <textarea class="form-control col-md-8 zeroRightPad placeholder" id="announcementDescription" name="announcementDescription" placeholder="Enter description" maxlength="500"
            rows="4" [(ngModel)]="announcementDescription" autocomplete="off" required></textarea>
      </div>
     
   
   
    </div>
    <div class="text-center col-md-12">

      <button type="submit" id="submitButton" *ngIf="editandSavebtn ==false && savebtn == true"
        class="btn btn-danger col-sm-2 col-md-2 style btn-width"
        [disabled]="(!chapterAnnouncementForm.valid  )  || fileSizeExtensionError || fileExtensionError || announceLinkValid"
        data-target="#myModal" data-toggle="modal">SAVE</button>
      <button type="submit" id="submitButton" *ngIf="editandSavebtn ==true && savebtn == false"
        class="btn btn-danger col-sm-2 col-md-2 style btn-width" [disabled]="!chapterAnnouncementForm.valid || announceLinkValid || fileSizeExtensionError || fileExtensionError "
        data-target="#myModal" data-toggle="modal">SAVE AND UPDATE</button>
      <span class="preview"></span>
      <button type="button" class="btn btn-danger col-sm-2 col-md-2 style btn-width" data-toggle="modal"
        (click)="resetClick()" data-target="#myModal">RESET</button>
    </div>

  </form>

  <div class="col-md-12  search-div-style">

    <div class="col-md-3 div-bottom" style="margin-left:10%"> 
      <ng-select placeholder="--Select Site--" [items]="siteListSearch" name="siteName" bindLabel="siteName"
        [(ngModel)]="selectedSiteSearch" (change)="siteChangeSearch($event)" required></ng-select>
    </div>
    <div class="col-md-3  div-bottom">
      <ng-select placeholder="--Select ERG--" [items]="bpgListSearch" name="bpgName" bindLabel="bpgName"
        [(ngModel)]="selectedBpgSearch" (change)="bpgChangeSearch($event)"></ng-select>
    </div>
<div class="col-md-2 div-bottom" style="margin-right:10%">
 <button type="button" class="btn btn-danger search-button-style gallery-but"
        (click)="getChapterAnnouncementListSearch()">Search</button>
    </div>
  </div>
</div>

<!--table-->
<p class="noDataFound text-center" *ngIf="noDataFound"> No data found </p>
<div class="tabledemo1" *ngIf="tableShow">
  <div class="table-container">
  <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
    <thead>
      <tr class="tr-th">
       <th scope="col">Site</th>
        <th scope="col">ERG</th>
        <th scope="col">Announcement Title</th>
       <th scope="col">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let data of announcementItemsList | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
       <td>{{data.siteName}}</td>
        <td>{{data.bpgName}}</td>
        <td>{{data.announcementTitle}}</td>
       <td class="edit-delete-button">
          <a id="edit{{i}}" (click)="editDocument(data,i)" class="edit-delete"><img src="assets/images/edit.png"
              class="image" title="Edit" alt="Angular Logo"></a>
          <a id="edit{{i}}" (click)="deleteAnnouncementConfirmation(data.chaptersAnnouncementId)" class="edit-delete"
            data-target="#myModal" data-toggle="modal"><img src="assets/images/delete.png" class="image" alt="Angular Logo"
              title="Delete"></a>
        </td>
      </tr>
    </tbody>
  </table>
  </div>
  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
  </div>
</div>
<app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>
